<template>
  <div class="mobile-group-list">
    <!-- 退出登录按钮 -->
    <div class="logout-button-container">
      <div class="logout-button" @click="$router.push('/')">
        <i class="el-icon-switch-button"></i>
        <span>退出登录</span>
      </div>
    </div>
    
    <div class="group-grid">
      <div 
        v-for="group in groupList" 
        :key="group.id" 
        class="group-item"
        @click="goGroupDev(group)"
      >
        <div class="group-name">{{ group.groupName }}</div>
        <div class="group-stats">
          <div class="stat-item">
            <span class="stat-label">设备数量</span>
            <span class="stat-value">{{ group.deviceNum || 0 }}</span>
          </div>
          <div class="stat-item">
            <span class="stat-label">应用数量</span>
            <span class="stat-value">{{ group.appNum || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 加载更多 -->
    <!-- <div class="load-more" v-if="hasMore" @click="loadMore">
      <el-button type="text" :loading="loading">加载更多</el-button>
    </div> -->
    
    <!-- 无数据提示 -->
    <div class="no-data" v-if="!loading && groupList.length === 0">
      <i class="el-icon-warning-outline"></i>
      <p>暂无分组数据</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MobileGroupList',
  data() {
    return {
      groupList: [],
      page: {
        startPage: 1,
        limit: 1000
      },
      loading: false,
      hasMore: true,
      total: 0
    }
  },
  created() {
    this.getGroupList()
  },
  methods: {
    // 获取分组列表
    getGroupList() {
      this.loading = true
      this.$post(this.$uri.group.list, this.page).then(res => {
        if (this.page.startPage === 1) {
          this.groupList = res.list || []
        } else {
          this.groupList = [...this.groupList, ...(res.list || [])]
        }
        this.total = res.total || 0
        this.hasMore = this.groupList.length < this.total
        // if (res.list && res.list.length === 1) {
        //     this.goGroupDev(res.list[0])
        //   }
        // 如果不是管理员且是第一次登录，并且只有一个分组，则直接跳转到该分组的设备列表
        if (!this.$store.state.isAdmin && this.$store.state.loginNow) {
          this.$store.commit(this.$mutation.LOGIN_NOW, false)
          if (res.list && res.list.length === 1) {
            this.goGroupDev(res.list[0])
          }
        }
      }).catch(error => {
        console.error('获取分组列表失败:', error)
        this.$message.error('获取分组列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    
    // 加载更多
    loadMore() {
      if (!this.hasMore || this.loading) return
      this.page.startPage++
      this.getGroupList()
    },
    
    // 跳转到组内设备页面
    goGroupDev(info) {
      this.$store.commit(this.$mutation.GROUP_DETAIL, info)
      // 如果是手机端，则跳转到移动端组内设备页面
      if (this.$store.state.isMobile) {
        this.$router.push(`/home/group/dev/mobile?groupId=${info.id}`)
      } else {
        this.$router.push("/home/group/dev")
      }
    },
  
    
  }
}
</script>

<style lang="less" scoped>
.mobile-group-list {
  padding: 0;
  background-color: #f5f7fa;
  min-height: 100vh;
  
  /* 退出登录按钮容器 */
  .logout-button-container {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 1000;
    
    .logout-button {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      background-color: #f56c6c;
      color: white;
      border-radius: 20px;
      font-size: 14px;
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
      transition: all 0.3s ease;
      
      i {
        margin-right: 5px;
        font-size: 16px;
      }
      
      &:hover {
        background-color: #f78989;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(245, 108, 108, 0.4);
      }
      
      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 6px rgba(245, 108, 108, 0.3);
      }
    }
  }
  
  .group-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    padding: 15px;
    margin-top: 50px;
    
    .group-item {
      background-color: #fff;
      border-radius: 8px;
      padding: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      transition: all 0.3s;
      
      &:active {
        transform: scale(0.98);
        box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.15);
      }
      
      .group-name {
        font-size: 16px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid #ebeef5;
      }
      
      .group-stats {
        display: flex;
        justify-content: space-between;
        
        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          
          .stat-label {
            font-size: 12px;
            color: #909399;
            margin-bottom: 5px;
          }
          
          .stat-value {
            font-size: 18px;
            font-weight: bold;
            color: #409EFF;
          }
        }
      }
    }
  }
  
  .load-more {
    text-align: center;
    margin-top: 20px;
    padding: 10px 0;
  }
  
  .no-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0;
    color: #909399;
    
    i {
      font-size: 40px;
      margin-bottom: 10px;
    }
    
    p {
      margin: 0;
      font-size: 14px;
    }
  }
}

/* 适配不同屏幕尺寸 */
@media (min-width: 768px) {
  .mobile-group-list {
    .group-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (min-width: 992px) {
  .mobile-group-list {
    .group-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@media (min-width: 1200px) {
  .mobile-group-list {
    .group-grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>